export default {
  resetToken({ commit }) {
    commit('removeAuthorization')
    commit('removeNickname')
    commit('removeMobile')
    commit('removeOpenid')
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js